import { useLocation, useNavigate } from "react-router-dom";
import "../styles/Questionnaire.css";
import { useEffect, useState } from "react";
import { useMutation, useQuery } from "@tanstack/react-query";
import { consultantPaymentApi } from "services/postApis";
import { ErrorHandler } from "utils/toast";
import ButtonLoader from "components/ButtonLoader";
import { getFeeDetailsApi } from "services/getApis";
import LoaderPulse from "components/Loader/LoaderPulse";

const ConsultationPayment = () => {
  const navigate = useNavigate();
  const loc = useLocation();
  const userSubmissionId = loc.state?.userSubmissionId;
  const bookAppointmentDescription = loc.state?.bookAppointmentDescription;
  const [isLoading, setIsLoading] = useState(false);

  console.log("bookAppointmentDescription:- ", bookAppointmentDescription);

  useEffect(() => {
    if (!userSubmissionId) {
      navigate("/questionnaire", { replace: true });
    }
  }, [userSubmissionId, navigate]);

  const feeType = bookAppointmentDescription
    ? "meeting_fees"
    : "consultation_fees";

  const {
    data: getFee,
    isError,
    error,
    isLoading: isLoadingFee,
  } = useQuery({
    queryKey: ["getFeeDetailsApi", feeType, userSubmissionId],
    queryFn: () =>
      getFeeDetailsApi({
        name: feeType,
        body: {
          userSubmissionId,
          type: bookAppointmentDescription ? "meeting" : "consultant",
          amount: bookAppointmentDescription ? 35 : 49,
        },
      }),
    enabled: !!userSubmissionId,
    retry: 3,
  });

  useEffect(() => {
    if (isError) {
      console.error("Error fetching fee details:", error);
      ErrorHandler(error);
    }
  }, [isError, error]);

  const { mutate: mutatePayment } = useMutation({
    mutationFn: consultantPaymentApi,
    onSuccess: (data) => {
      console.log("Payment API Response:", data);
      //      navigate(`/${userSubmissionId}/validate-payment`, {
      //   replace: true,
      //   state: { userSubmissionId, responseData },
      // });
      setIsLoading(false);

      // Redirect to Stripe checkout
      const checkoutLink = data?.payload?.link;
      if (checkoutLink) {
        window.location.href = checkoutLink;
      }
    },
    onError: (error) => {
      console.error("Payment API Error:", error);
      ErrorHandler(error);
      setIsLoading(false);
    },
  });

  const handleContinue = () => {
    setIsLoading(true);
    if (bookAppointmentDescription) {
      navigate("/schedule", { state: { userSubmissionId } });
    } else {
      mutatePayment({
        userSubmissionId,
        amount: getFee?.payload?.value,
        type: bookAppointmentDescription ? "meeting" : "consultant",
      });
    }
  };

  return (
    <div className="questionnaire-container">
      <div className="questionnaire-content">
        {isLoadingFee ? (
          <div
            style={{
              position: "fixed",
              top: -120,
              left: 0,
              right: 0,
              bottom: 0,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <LoaderPulse />
          </div>
        ) : (
          <>
            <div className="content-card">
              <div className="payment-screen">
                <h2 className="payment-title">Consultation Fee</h2>
                <p className="payment-subtitle">
                  {bookAppointmentDescription
                    ? bookAppointmentDescription
                    : "Your payment enables our specialist to review your prescription and provide expert insights."}
                </p>
                <div className="fee-card">
                  <div className="fee-row">
                    <span className="fee-label">Total Fee</span>
                    <span className="fee-amount">
                      ${getFee?.payload?.value}
                    </span>
                  </div>
                </div>
                <button
                  className="payment-btn"
                  onClick={handleContinue}
                  disabled={isLoading}
                >
                  {isLoading ? <ButtonLoader /> : "Pay Now"}
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ConsultationPayment;
